module.exports = __webpack_public_path__ + "img/1498601339.6ef38e99.jpg";